export function getGraphQLErrorMessage(error) {
  let msg = ''
  if (Array.isArray(error)) {
    msg = error
      .map((err) => err.message)
      .filter((m) => m)
      .join(',')
  }

  return msg
}
